(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('blocked-phone', {
            parent: 'entity',
            url: '/blocked-phone?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.blockedPhone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/blocked-phone/blocked-phones.html',
                    controller: 'BlockedPhoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('blockedPhone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('blocked-phone-detail', {
            parent: 'blocked-phone',
            url: '/blocked-phone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.blockedPhone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-detail.html',
                    controller: 'BlockedPhoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('blockedPhone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BlockedPhone', function($stateParams, BlockedPhone) {
                    return BlockedPhone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'blocked-phone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('blocked-phone-detail.edit', {
            parent: 'blocked-phone-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-dialog.html',
                    controller: 'BlockedPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BlockedPhone', function(BlockedPhone) {
                            return BlockedPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('blocked-phone.new', {
            parent: 'blocked-phone',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN','ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-dialog.html',
                    controller: 'BlockedPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                callsCount: null,
                                lastCallTime: null,
                                blockerCaption: null,
                                blockingTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }, function() {
                    $state.go('blocked-phone');
                });
            }]
        })
        .state('blocked-phone.edit', {
            parent: 'blocked-phone',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-dialog.html',
                    controller: 'BlockedPhoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BlockedPhone', function(BlockedPhone) {
                            return BlockedPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('blocked-phone.delete', {
            parent: 'blocked-phone',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/blocked-phone/blocked-phone-delete-dialog.html',
                    controller: 'BlockedPhoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BlockedPhone', function(BlockedPhone) {
                            return BlockedPhone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('blocked-phone', null, { reload: 'blocked-phone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
